import styled, { css, keyframes } from 'styled-components';
import { Stack } from 'src/components';

export const Wrapper = styled(Stack)<{ $showAnimation: boolean }>(
  ({ theme, $showAnimation }) => css`
    width: 100%;
    text-align: center;
    margin-bottom: ${$showAnimation ? 0 : `${theme.sz.s1}`};
  `,
);

export const AnimationTitle = styled.h2(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
    font-size: ${theme.sz.s4};
    margin: 0 0 ${theme.sz.s2} 0;
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
    font-size: ${theme.sz.s5};
    margin-top: ${theme.sz.s4};
  `,
);

export const Topic = styled.h4<{
  $isPremiumScenario?: boolean;
  $completed: boolean;
}>(
  ({ theme, $isPremiumScenario, $completed }) => css`
    text-transform: uppercase;
    color: ${
      $completed
        ? theme.co.information30
        : $isPremiumScenario
          ? theme.co.error20
          : theme.co.success30
    };
    font-size: ${theme.sz.s3};
  `,
);

export const AdditionalText = styled.small(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    margin-top: ${theme.sz.s2};
    margin-bottom: ${theme.sz.s4};
  `,
);

const iconAnimation = keyframes`
  0%,
  51%,
  100% {
    transform: scale(1);
  }
  66% {
    transform: scale(.8);
  }
  85% {
    transform: scale(1.2);
  }
`;

export const IconContainer = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.sz.s14};
    left: ${theme.sz.s14};
    animation-name: ${iconAnimation};
    animation-duration: 1s;
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    width: ${theme.sz.s48};
    height: ${theme.sz.s48};
  `,
);
